import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbdSortableHeader } from './directives/sort.directive';
import { ConfirmationModalComponent } from './common/confirmation-modal/confirmation-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [NgbdSortableHeader, ConfirmationModalComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbModule],
  exports: [
    CommonModule,
    NgbdSortableHeader,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
  ],
})
export class SharedModule {}
